import ActionsTypes from '../../constants/ActionsTypes'

////////LIBRARY/////////
const kioskEditImplantation = {
	postKioskEditImplantation: (filters = {}, requestId, queryParams = { page: '0', size: '250' }) => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION,
		payload: {
			filters,
			requestId,
			queryParams,
		},
	}),
	postKioskEditImplantationSuccess: (data, id) => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_SUCCESS,
		payload: {
			data,
			id,
		},
	}),
	postKioskEditImplantationFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_FAILURE,
		payload: {
			error,
		},
	}),
	getKioskEditImplantationItemsCatalogGrowth: (requestId, requestUrl) => ({
		type: ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH,
		payload: {
			requestId,
			requestUrl,
		},
	}),
	getKioskEditImplantationItemsCatalogGrowthSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_SUCCESS,
		payload: {
			data,
		},
	}),
	getKioskEditImplantationItemsCatalogGrowthFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH_FAILURE,
		payload: {
			error,
		},
	}),

	postKioskEditImplantationUnitActionWithId: (toast, caseList, requestId, query, arg = '') => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID,
		payload: {
			toast,
			caseList,
			requestId,
			query,
			arg,
		},
	}),
	postKioskEditImplantationUnitActionWithIdSuccess: (data) => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_SUCCESS,
		payload: {
			data,
		},
	}),
	postKioskEditImplantationUnitActionWithIdFailure: (error) => ({
		type: ActionsTypes.POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID_FAILURE,
		payload: {
			error,
		},
	}),

	putKioskEditImplantationValidateImplantation: (requestId) => ({
		type: ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION,
		payload: {
			requestId,
		},
	}),
	putKioskEditImplantationValidateImplantationSuccess: (data) => ({
		type: ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_SUCCESS,
		payload: {
			data,
		},
	}),
	putKioskEditImplantationValidateImplantationFailure: (error) => ({
		type: ActionsTypes.PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataEditImplantation: () => ({
		type: ActionsTypes.RESET_DATA_EDIT_IMPLANTATION,
	}),

	resetErrorImplantation: (bool) => ({
		type: ActionsTypes.RESET_ERROR_EDIT_IMPLANTATION,
		payload: {
			bool,
		},
	}),
}

export default kioskEditImplantation
